// Module
var code = `<template class="report-page \${printing ? 'report-page__printed':''}">
  <require from="./report-page.scss"></require>
  <grid-stack view-model.ref="grid" float change.trigger="handleGridChange()" widget-change.trigger="handleGridChange()" options.bind="gridStackOptions" click.trigger="handleGridClick(\$event)">
    <grid-stack-item repeat.for="w of widgets" x.bind="w.x" y.bind="w.y" w.bind="w.w" h.bind="w.h" remove.delegate="removeWidget(w, \$index)" class="\${w.selected ? 'grid-stack-item--selected' : ''} report-page__widget-\${pageNumber}-\${subPageNumber}-\${\$index}" click.trigger="handleGridItemClick(w) & stopPropagation">

      <!-- beautify ignore:start -->
      <style>
        .report-page__widget-\${pageNumber}-\${subPageNumber}-\${\$index} .report-page__widget-title {
          font-family: \${w.compose.currentViewModel.titleFont ? w.compose.currentViewModel.titleFont : 'Roboto' };
          font-size: \${w.compose.currentViewModel.titleFontSize ? w.compose.currentViewModel.titleFontSize : 16}px;
          color: \${w.compose.currentViewModel.titleColor ? w.compose.currentViewModel.titleColor : 'black'} !important;
          text-align: \${w.compose.currentViewModel.titleAlign ? w.compose.currentViewModel.titleAlign : 'left'};
        }

        .report-page__widget-\${pageNumber}-\${subPageNumber}-\${\$index} .widget__content {
          border-style: solid;
          border-width: \${w.compose.currentViewModel.borderWidth || 0};
          border-color: \${w.compose.currentViewModel.borderColor || 'transparent'};
        }

        .report-page__widget-\${pageNumber}-\${subPageNumber}-\${\$index} .widget__content compose {
          padding: \${w.compose.currentViewModel.padding || 0};
        }
      </style>
      <!-- beautify ignore:end -->

      <div class="widget__content">
        <div class="\${w.compose.currentViewModel.title ? 'report-page__widget-title' : ''}">\${w.compose.currentViewModel.title}</div>
        <compose view-model.bind="w.viewModel" model.bind="w.config" view-model.ref="w.compose">
        </compose>
      </div>
      <div class="report-page__hover"></div>
      <mdc-icon if.bind="!readonly" class="report-page__widget-drag-area md-18">open_with</mdc-icon>
    </grid-stack-item>
  </grid-stack>
</template>
`;
// Exports
export default code;